import { Component, EventEmitter, OnInit, Output, HostListener, ElementRef , ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons}   from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {HttpClient,HttpClientModule,HttpHeaders,} from '@angular/common/http';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ApidataService } from '../apidata.service';
import { Router, Params, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-share',
  standalone: true,
  imports: [NgbDatepickerModule, HttpClientModule,CommonModule,
    ReactiveFormsModule,
    FormsModule,
   ],
  templateUrl: './share.component.html',
  styleUrl: './share.component.css'
})
export class ShareComponent {
  closeResult = '';
  copylinkture: boolean = false;
  clipboardtext = "";
  color: string = "black";
  doc_id = "";
  saveFileText = "";

  constructor(private modalService: NgbModal,
    private router: Router,
    private apiservice: ApidataService,
     private http:HttpClient ,
    private elementRef: ElementRef,) {}
  @ViewChild('content', { static: true }) content: TemplateRef<any>;

  ngOnInit() {    
    this.openModal();

  }
  openModal() {    
    this.modalService.open(this.content,{ backdrop: 'static', keyboard: false , centered: true,  windowClass: 'my-class'});
  }
  openModels(content:any, data:any=null){
    this.modalService.open(content,{size:"lg"})
    }
    closeModal(){
      this.modalService.dismissAll();
    }

    // shre code start
   copyToClipboard(tag): void {

      const inputElement = document.getElementById(tag);
      (<any>inputElement).select();
      document.execCommand("copy");
      inputElement.blur();
      this.copylinkture = true;
      this.color = "green";
      this.clipboardtext = "Link Copied to Clipboard!";
    }
   // shre code end
}
